export const AVATAR_COLORS = [
    '#2c7be5', // primary (azul)
    '#00d27a', // success (verde)
    '#27bcfd', // info (azul claro)
    '#f5803e', // warning (naranja)
    '#e63757', // danger (rojo)
    '#8d6cef'  // morado
];

export function getInitials(prefijo) {
    return (prefijo || '').trim().substring(0, 2).toUpperCase();
}

function hashSeed(seed) {
    let hash = 0;
    const str = seed || '';
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
}

export function getAvatarColor(seed) {
    return AVATAR_COLORS[hashSeed(seed) % AVATAR_COLORS.length];
}
